<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="reservedAdvs"
            :loading="loading" :total="reservedAdvs"
            :label="`adv(s) en cours`">
      <a @click="expordGed" class="dropdown-item" slot="dropdown-content"
         v-if="(isAdmin || isSectorManager) && !multiselection && gedEnabled">
        <span class="icon"><i class="fas fa-file-export"></i></span>
        <span>Exporter fichier GED (KB)</span>
      </a>
      <a @click="exportXls('advs-export-lite', query, true, 'ADV-Export')" class="dropdown-item" slot="dropdown-content"
         v-if="(isAdmin || isSectorManager )&& !multiselection">
        <span class="icon"><i class="fas fa-file-export"></i></span>
        <span>Exporter données ADV</span>
      </a>
<!--      <a @click="openGedModal" class="dropdown-item" slot="dropdown-content"-->
<!--         v-if="isAdmin && !multiselection && gedExportEnabled">-->
<!--        <span class="icon"><i class="fas fa-file-export"></i></span>-->
<!--        <span>Visualiser le fichier GED</span>-->
<!--      </a>-->
<!--      <a @click="exportXls('advs-export', query, true, 'ADV-Export-GED')" class="dropdown-item" slot="dropdown-content"-->
<!--         v-if="isAdmin && !multiselection  && !gedExportEnabled">-->
<!--        <span class="icon"><i class="fas fa-file-export"></i></span>-->
<!--        <span>Exporter fichier GED</span>-->
<!--      </a>-->
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser données</span>
      </a>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="page-content columns collapseColumn collapseColumn--left collapseColumn--alignStart"
         id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetFilters"
                     @changeFilters="changeFilters"
                     :hasFilter="hasFilter"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     @opened="opened = !opened">
          <div class="columns">
            <div class="column is-paddingless-bottom">
              <div class="control">
                <multiselect @select="updateBuyerFilter" @remove="updateBuyerFilter(null)"
                             v-model="filters.buyer" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :options="buyers" :searchable="true" :show-labels="false"
                             @search-change="getBuyers" :placeholder="''"
                             :custom-label="personName">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="buyers.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun acquéreur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Acquéreur</span>
                  <span slot="placeholder" class="multiselect__placeholder">Acquéreur</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-xsmall" v-if="isDistributeurMode && (isAdmin || isSectorManager)">
              <div class="control">
                <multiselect @select="updatePromoteurFilter" @remove="updatePromoteurFilter(null)"
                             v-model="filters.promoteur" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :options="promoteurs" :searchable="true" :show-labels="false"
                             @search-change="getPromoteurs" :placeholder="''">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="promoteurs.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Promoteur</span>
                  <span slot="placeholder" class="multiselect__placeholder">Promoteur</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updateProgramFilter" @remove="updateProgramFilter(null)"
                             class="multiselect--option-ico"
                             v-model="filters.program" label="name" track-by="pk"
                             :options="programs" :searchable="true" :show-labels="false"
                             :placeholder="''" @search-change="getPrograms">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="programs.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Programme</span>
                  <span slot="placeholder" class="multiselect__placeholder">Programme</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="filters.program">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updateLotFilter" @remove="updateLotFilter(null)"
                             class="multiselect--option-ico"
                             v-model="filters.lot" label="ref" track-by="pk"
                             :options="lots" :searchable="true" :show-labels="false"
                             @search-change="getLots" :placeholder="''">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="lots.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun lot trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Lot</span>
                  <span slot="placeholder" class="multiselect__placeholder">Lot</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isAdmin || isSectorManager">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updateSellerFilter" @remove="updateSellerFilter(null)"
                             v-model="filters.seller" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :options="sellers" :searchable="true" :show-labels="false"
                             @search-change="getSellers" :placeholder="''"
                             :custom-label="personName">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="sellers.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun vendeur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Vendeur</span>
                  <span slot="placeholder" class="multiselect__placeholder">Vendeur</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isAdmin || isSectorManager">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updateCompanyFilter" @remove="updateCompanyFilter(null)"
                             v-model="filters.company" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :options="companies" :searchable="true" :show-labels="false"
                             @search-change="getCompanies" :placeholder="''">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="companies.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucune société trouvée.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Société</span>
                  <span slot="placeholder" class="multiselect__placeholder">Société</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isAdmin || isSectorManager">
            <div class="column is-paddingless-bottom is-padding-top-xsmall">
              <div class="control">
                <multiselect @select="updatePoleFilter" @remove="updatePoleFilter"
                             v-model="filters.pole" label="name" track-by="pk"
                             class="multiselect--option-ico"
                             :multiple="true" :close-on-select="false"
                             :options="poles" :searchable="true" :show-labels="false"
                             @search-change="getPoles" :placeholder="''">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="poles.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun pôle trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="selection" class="multiselect__placeholder" slot-scope="{ values }" v-if="values.length">
                    <span>Pôle(s) ({{values.length}})</span>
                  </span>
                  <span slot="placeholder" class="multiselect__placeholder">Pôle</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Pôle</span>
                </multiselect>
              </div>
            </div>
          </div>
          <!-- correspond au champs reservation_date-->
          <!-- <div class="columns is-padding-left is-padding-right">
            <div class="column is-paddingless-left is-paddingless-right">
              <div class="field">
                <label class="label">Date d'enregistrement</label>
                <flat-pickr :config="configDate" v-model="reservationDate"
                            @on-open="reservationDateOpened = true" @on-close="reservationDateClosed = true"
                            class="input is-radiusless" name="date"
                            @on-change="updateReservationDateFilter">
                </flat-pickr>
              </div>
            </div>
          </div> -->
          <!-- correspond au champs signature_date-->
          <div class="columns is-padding-left is-padding-right">
            <div class="column is-paddingless-left is-paddingless-right is-paddingless-bottom is-padding-top-xsmall">
              <div class="field has-addons">
                <div class="control">
                  <a
                          class="button is-square is-static is-border is-min-width-0 is-padding-left-xsmall is-padding-right-xsmall">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr :config="configDate" v-model="signatureDate"
                              class="input is-padding-left-xsmall is-paddingless-right" name="date"
                              placeholder="Réservation"
                              @on-change="updateSignatureDateFilter">
                  </flat-pickr>
                </div>
                <div class="control">
                  <a
                          class="button is-square is-grey is-inverted is-border is-min-width-0 is-padding-left-small is-padding-right-small"
                          @click="signatureDate = null">
                    <span class="icon"><i class="fas fa-times"></i></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-padding-left is-padding-right">
            <div class="column is-paddingless-left is-paddingless-right is-paddingless-bottom is-padding-top-xsmall">
              <div class="field has-addons">
                <div class="control">
                  <a
                          class="button is-square is-static is-border is-min-width-0 is-padding-left-xsmall is-padding-right-xsmall">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr :config="configDate" v-model="saleDate"
                              @on-open="saleDateOpened = true" @on-close="saleDateClosed = true"
                              class="input is-padding-left-xsmall is-paddingless-right" name="date"
                              placeholder="Acte"
                              @on-change="updateSaleDateFilter">
                  </flat-pickr>
                </div>
                <div class="control">
                  <a
                          class="button is-square is-grey is-inverted is-border is-min-width-0 is-padding-left-small is-padding-right-small"
                          @click="saleDate = null">
                    <span class="icon"><i class="fas fa-times"></i></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom">
            <label class="label">Destinations</label>
            <div class="columns is-multiline is-padding-top-xsmall">
              <div class="control column is-narrow is-paddingless" v-for="s in advDestinationsList" :key="s.value">
                <input type="checkbox" class="is-checkradio is-small" v-model="filters.destination" :value="s.value"
                       :name="s.value" :id="s.value" @click="inputChange">
                <label class="checkbox" :for="s.value">{{s.label}}</label>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isAdmin || isSectorManager">
            <div class="column is-paddingless-top">
              <div class="control">
                <div class="select is-fullwidth">
                  <select
                          :disabled="!filters.destination || !filters.destination.length || !filters.destination.includes('invest') "
                          v-model="filters.mandat_de_gestion" @input="changeFilters()">
                    <option :value="null" selected>Mandat de gestion</option>
                    <option :value="1">Oui</option>
                    <option :value="0">Non</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </list-filter>
      </div>

      <div class="column is-8 is-9-widescreen is-9-fullhd is-paddingless-bottom">
        <additional-filter :display-pane="displayAdminFilterPane"
                           v-if="isAdmin || isSectorManager" :has-margin="false"
                           @togglePane="displayAdminFilterPane = !displayAdminFilterPane"
                           class="has-bg-light">
          <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster"
                      mode="out-in" slot="left-column-title">
            <div v-if="!loading && (hasFilter || total !== reservedAdvs)"
                 class="column is-narrow has-bg-primary columns is-vcentered is-gapless">
              <div class="column is-narrow is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}}
                ADV(s)
              </div>
            </div>
          </transition>
          <div slot="column" class="column is-paddingless"></div>
          <div slot="column" v-if="multiselection && selectedItems.length" class="column is-narrow is-border-left">
            <a @click="exportMultiselect" class="page-header-btn is-small is-success">
              <span class="icon"><i class="fas fa-file-export"></i></span>
              <span>Exporter fichier GED ({{selectedItems.length}})</span>
            </a>
          </div>
          <div slot="column" v-if="multiselection && selectedItems.length" class="column is-narrow is-border-left">
            <a @click="exportMultiselectLite" class="page-header-btn is-small is-success">
              <span class="icon"><i class="fas fa-file-export"></i></span>
              <span>Exporter données ADV ({{selectedItems.length}})</span>
            </a>
          </div>
          <div slot="column" class="column is-narrow is-border-left" v-if="!multiselection">
            <a @click="multiselection = !multiselection" data-tooltip="Sélection multiple"
               class="page-header-btn is-small is-square tooltip is-tooltip-left is-tooltip-primary">
              <span class="icon"><i class="fas fa-tasks"></i></span>
            </a>
          </div>
          <div slot="column" class="column is-narrow is-border-left" v-else>
            <a @click="cancelMultiselect"
               class="page-header-btn is-small is-info is-square tooltip is-tooltip-bottom is-tooltip-primary"
               data-tooltip="Annuler la sélection">
              <span class="icon"><i class="fas fa-tasks has-text-white"></i></span>
            </a>
          </div>
        </additional-filter>
        <div class="is-padding-top is-padding-right is-padding-left is-border-left is-border-right has-bg-light"
             v-if="hasFilter && !loading">
          <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
          <div class="tags">
            <span class="tag is-primary is-rounded" v-if="filters.buyer">
              {{personName(filters.buyer)}} <a @click="updateBuyerFilter(null)"
                                               class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.promoteur">
              {{filters.promoteur.name}} <a @click="updatePromoteurFilter(null)"
                                            class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.program">
              {{filters.program.name}} <a @click="updateProgramFilter(null)"
                                          class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.lot">
              {{filters.lot.ref}} <a @click="updateLotFilter(null)" class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.seller">
              {{personName(filters.seller)}} <a @click="updateSellerFilter(null)"
                                                class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.company">
              {{filters.company.name}} <a @click="updateCompanyFilter(null)"
                                          class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.pole && filters.pole.length"
                  v-for="(pole, i) in filters.pole" :key="'pole-' + i">
              {{pole.name}} <a @click="deletePoleFilter(i)" class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="signatureDate">
              Réservation : {{signatureDate}} <a @click="signatureDate = null"
                                                 class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="saleDate">
              Acte : {{saleDate}} <a @click="saleDate = null" class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.destination && filters.destination.length"
                  v-for="(destination, i) in filters.destination" :key="'destination-' + i">
              {{destination | contactResearchLabel}} <a @click="deleteDestinationFilter(i)"
                                                        class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.mandat_de_gestion !== null">
              <span v-if="filters.mandat_de_gestion === '0' || filters.mandat_de_gestion === 0">Sans mandat de gestion</span>
              <span v-else>Avec mandat de gestion</span> <a @click="updateMandatFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFilters">
              Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-undo"></i></span>
            </span>
          </div>
        </div>
        <div v-if="!loading" class="column is-narrow is-padding-top is-padding-bottom is-border-left is-border-right has-bg-light">
          <label class="checkbox checkRadioIsHide is-padding-right-xsmall" :for="s.value"
                 v-for="s in availableAdvStatusList" :key="s.value">
            <input type="checkbox" :id="s.value" v-model="filters.status" @click="inputChange" :value="s.value">
            <span class="tag" :class="tagColors(s.value)">
              <span>{{s.label}}</span>
              <span class="icon">
                <i class="far"
                   :class="!filters.status || !filters.status.length || filters.status.includes(s.value) ? 'fa-check-square' : 'fa-square'"></i>
              </span>
            </span>
          </label>
        </div>
        <div>
          <div class="is-border" v-show="!loading && items.length">
            <table-h-scroll :reload-controls="loading && items.length" :sticky-styles="stickyStyles"
                            :has-sticky="true" :sticky-datas="stickyDatas">
              <table
                      class="table is-fullwidth is-narrow is-striped-v is-first-fixed-small is-second-fixed-small is-last-fixed-small is-marginless-bottom has-actionsontd">
                <thead>
                <tr class="is-size-6">
                  <th class="is-paddingless has-text-centered actions" style="z-index:2;">
                    <button v-if="multiselection" class="button is-small is-light is-circle"
                            @click="selectItemToggleAll(items)">
                      <i class="far fa-check-double"></i>
                    </button>
                    <div v-else class="dropdown is-hoverable is-left">
                      <div class="dropdown-trigger">
                        <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                          <i class="fal fa-cog"></i>
                        </button>
                      </div>
                      <columns-toggles :entries="columnsList" :source="columns"
                                       @update="updateColumns"></columns-toggles>
                    </div>
                  </th>
                  <th class="is-groupcols-1a">
                    <sortable @sort="sort('status', $event)" :sort="sortBy.status" label="Statut"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a">
                    <sortable @sort="sort('ref', $event)" :sort="sortBy.ref" label="Réf."></sortable>
                    <div class="deco"></div>
                  </th>
                  <!-- <th class="is-groupcols-1a" v-if="showColumn('reservation_date')"
                      :class="{'app--hide-on-tablet': !showOnMobile('reservation_date')}">
                    <sortable @sort="sort('reservation_date', $event)" :sort="sortBy.reservation_date"
                              label="Date d'enregistrement"></sortable>
                    <div class="deco"></div>
                  </th> -->
                  <th class="is-groupcols-1a">
                    <sortable @sort="sort('lot_ref', $event)" :sort="sortBy.lot_ref" label="Lot"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="showColumn('program_name')">
                    <sortable @sort="sort('program_name', $event)" :sort="sortBy.program_name"
                              label="Programme"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="showColumn('signature_date')">
                    <sortable @sort="sort('signature_date', $event)" :sort="sortBy.signature_date"
                              label="Réservation"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-cell-hoverable is-groupcols-1a" v-if="(isAdmin || isSectorManager) && showColumn('company_name')">
                    <sortable @sort="sort('company_name', $event)" :sort="sortBy.company_name"
                              label="Société"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-cell-hoverable is-groupcols-1a"
                      v-if="isDistributeurMode && (isAdmin || isSectorManager) && showColumn('promoteur_name')">
                    <sortable @sort="sort('promoteur_name', $event)" :sort="sortBy.promoteur_name"
                              label="Promoteur"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="(isAdmin || isManager || isSectorManager) && showColumn('seller_name')">
                    <sortable @sort="sort('seller_name', $event)" :sort="sortBy.seller_name" label="Vendeur"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="showColumn('buyer_name')">
                    <sortable @sort="sort('buyer_name', $event)" :sort="sortBy.buyer_name" label="Acquéreur"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="showColumn('sale_date')">
                    <sortable @sort="sort('sale_date', $event)" :sort="sortBy.sale_date" label="Acte"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="showColumn('destination')">
                    <sortable @sort="sort('destination', $event)" :sort="sortBy.destination"
                              label="Destination"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="showColumn('mandat_de_gestion')">
                    <sortable @sort="sort('mandat_de_gestion', $event)" :sort="sortBy.mandat_de_gestion"
                              label="Mandat de Gestion"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="showColumn('reservation_date')">
                    <sortable @sort="sort('reservation_date', $event)" :sort="sortBy.reservation_date"
                              label="Enregistrement"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="showColumn('updated_on')">
                    <sortable @sort="sort('updated_on', $event)" :sort="sortBy.updated_on"
                              label="Modification"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="showColumn('contrat_de_reservation_is_valid')">
                    <sortable @sort="sort('contrat_de_reservation_is_valid', $event)"
                              :sort="sortBy.contrat_de_reservation_is_valid"
                              label="Contrat de réservation"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a has-text-centered"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(adv, index) in items" :key="adv.pk" class="is-size-6" :id="'e' + adv.pk"
                    :class="{'has-status-bar--left has-status-bar--draft':scrollToEl === adv.pk}">
                  <td class="is-cell-hoverable is-paddingless has-text-centered actions">
                    <router-link v-if="!multiselection"
                                 :to="{name: 'AdvInfos', params: {id: adv.pk}, query: {returnId: adv.pk}}">
                      <avatar :item="adv" :i="index"></avatar>
                    </router-link>
                    <multiselect-button v-else
                                        :data="adv"
                                        :is-checked="checkedItem(adv.pk)"
                                        :multiselection="multiselection"
                                        @selected="selectItem">
                    </multiselect-button>
                  </td>
                  <td class="has-text-centered">
                    <span class="dot tooltip" :class="adv.status|dotClass"
                          :data-tooltip="adv.status|statusLabel"></span>
                  </td>
                  <router-link class="is-cell-hoverable" tag="td"
                               :to="{name: 'AdvInfos', params: {id: adv.pk}, query: {returnId: adv.pk}}">
                    <a class="fullLink"><span>{{adv.ref}}</span></a>
                  </router-link>
                  <!-- <td v-if="showColumn('reservation_date')">
                      <span v-if="adv.reservation_date">
                        {{ adv.reservation_date | dtFormat('DD/MM/YYYY') }}
                      </span>
                    <span v-else>N/A</span>
                  </td>
                  <router-link v-else tag="td" class="is-cell-hoverable" :to="{name: 'AdvRecap', params: {id: adv.pk}}">
                    <a class="fullLink"><span>{{adv.ref}}</span></a>
                  </router-link> -->
                  <router-link tag="td" class="is-cell-hoverable"
                               :to="{name: 'LotVue', params: {id: adv.lot.pk || adv.lot}, query: {returnId: adv.pk}}">
                    <!-- <a class="fullLink"><span>{{adv.lot_ref | truncate(5)}}</span></a> -->
                    <a class="fullLink"><span>{{adv.lot_ref}}</span></a>
                  </router-link>
                  <td v-if="showColumn('program_name')" class="is-cell-hoverable">
                    <router-link :to="{name:'ProgramVue', params: {id: adv.program}, query: {returnId: adv.pk}}">
                      {{adv.program_name}}
                    </router-link>
                  </td>
                  <td v-if="showColumn('signature_date')">
                        <span v-if="adv.signature_date">
                          {{ adv.signature_date | dtFormat('DD/MM/YYYY') }}
                        </span>
                    <span v-else>N/A</span>
                  </td>
                  <td v-if="(isAdmin || isSectorManager) && showColumn('company_name')" class="is-cell-hoverable">
                    <router-link v-if="adv.company"
                                 :to="{name: 'CompanyVue', params: {id: adv.company}, query: {returnId: adv.pk}}">
                      {{adv.company_name}}
                    </router-link>
                    <span v-else>--</span>
                  </td>
                  <td v-if="isDistributeurMode && (isAdmin || isSectorManager) && showColumn('promoteur_name')" class="is-cell-hoverable">
                    <router-link v-if="adv.promoteur"
                                 :to="{name: 'PromoteurVue', params: {id: adv.promoteur}, query: {returnId: adv.pk}}">
                      {{adv.promoteur_name}}
                    </router-link>
                    <span v-else>--</span>
                  </td>
                  <td v-if="(isAdmin || isManager || isSectorManager) && showColumn('seller_name')" class="is-cell-hoverable">
                    <router-link :to="{name: 'UserVue', params: {id: adv.seller}, query: {returnId: adv.pk}}">
                      {{adv.seller_name}}
                    </router-link>
                  </td>
                  <td v-if="showColumn('buyer_name')" class="is-cell-hoverable">
                    <router-link :to="{name: 'ContactVue', params: {id: adv.buyer}, query: {returnId: adv.pk}}">
                      {{adv.buyer_name}}
                    </router-link>
                  </td>
                  <td v-if="showColumn('sale_date')">
                      <span v-if="adv.sale_date">
                        {{ adv.sale_date | dtFormat('DD/MM/YYYY') }}
                      </span>
                    <span v-else>--</span>
                  </td>
                  <td v-if="showColumn('destination')">
                    <span v-if="adv.destination">{{adv.destination | contactResearchLabel}}</span>
                    <span v-else>NC</span>
                  </td>
                  <td v-if="showColumn('mandat_de_gestion')">
                    <span v-if="adv.destination === 'invest' && adv.mandat_de_gestion === true">Oui</span>
                    <span v-else-if="adv.destination === 'invest' && adv.mandat_de_gestion === false">Non</span>
                    <span v-else-if="adv.destination === 'invest'">NC</span>
                    <span v-else></span>
                  </td>
                  <td v-if="showColumn('reservation_date')">
                    <span v-if="adv.reservation_date">{{adv.reservation_date | dtFormat('DD/MM/YYYY')}}</span>
                    <span v-else>NC</span>
                  </td>
                  <td v-if="showColumn('updated_on')">
                    <span v-if="adv.updated_on">{{adv.updated_on | dtFormat('DD/MM/YYYY')}}</span>
                    <span v-else>NC</span>
                  </td>
                  <td v-if="showColumn('contrat_de_reservation_is_valid')">
                    <span v-if="adv.contrat_de_reservation_is_valid">Oui</span>
                    <span v-else>Non</span>
                  </td>
                  <td class="has-text-centered">
                    <display-button-list :buttons="buttonList" :data="adv"
                                         :openUp="{'position': index, 'total': items.length}">
                    </display-button-list>
                  </td>
                </tr>
                <tr class="empty empty--row" v-for="n in items.length < 4 ? 4 - items.length : 0 " :key="n">
                  <td class="is-borderless"></td>
                </tr>
                </tbody>
              </table>
            </table-h-scroll>
          </div>
          <div class="is-border-top" v-if="totalPage > 1 && nextPage && !loading">
            <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
              <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
              <span class="is-size-6">Afficher la suite</span>
            </a>
            <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px">
            </div>
          </div>
          <div v-show="!loading && !items.length" class="is-border">
            <div class="columns">
              <div class="column">
                <h2 class="title is-3 has-text-weight-bold">Aucune adv disponible</h2>
                <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
                  class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ged-export-modal :active="gedExportModal" @close="gedExportModal = false"></ged-export-modal>
  </div>
</template>

<script>
  import {
    GenericList,
    Sort,
    Filter,
    DefaultValues,
    OptionStatus,
    ColumnConf,
    MultiSelection,
    TableHeaderSticky
  } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import { isNil, debounce, isPlainObject, uniq } from 'lodash'
  import moment from 'moment'
  import { downloadURI, exportXls } from '../../utils'
  import GedExportModal from './GedExportModal'

  export default {
    name: 'AdvList',
    components: { GedExportModal },
    mixins: [GenericList, Sort, Filter, DefaultValues, OptionStatus, ColumnConf, MultiSelection, TableHeaderSticky],
    data () {
      return {
        filters: {
          status: ['sold', 'reserved'],
          destination: [],
          mandat_de_gestion: null,
          pole: []
        },
        initFilters: {
          status: ['sold', 'reserved'],
          destination: [],
          mandat_de_gestion: null,
          pole: []
        },
        buttonList: [
          {
            icon: 'fa-eye',
            text: 'Voir',
            display: (adv) => {
              return true
            },
            action: (advPk) => {
              this.goToAdvView(advPk)
            }
          }
        ],
        columnsConfResource: 'advs',
        opened: true,
        loadDocuments: this.loadItems,
        service: this.$api.advService,
        advs: [],
        programs: [],
        lots: [],
        buyers: [],
        sellers: [],
        companies: [],
        promoteurs: [],
        poles: [],
        defaultColumns: ['buyer_name', 'reservation_date', 'seller_name'],
        saleDate: null,
        signatureDate: null,
        reservationDate: null,
        exportXls,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y',
          mode: 'range'
        },
        saleDateOpened: false,
        saleDateClosed: false,
        reservationDateOpened: false,
        reservationDateClosed: false,
        reservedAdvs: 0,
        infiniteLoaderEnabled: true,
        gedExportModal: false
      }
    },
    computed: {
      ...mapState({
        scrollToEl: 'scrollToEl',
        configs: 'configs',
        promoteursList: 'promoteurs',
        polesList: 'poles',
        companiesList: 'companies'
      }),
      ...mapGetters(['isAdmin', 'isManager', 'isSectorManager', 'isDistributeurMode']),
      gedEnabled () {
        if ('GED_ENABLED' in this.configs && this.configs.GED_ENABLED) {
          return this.configs.GED_ENABLED.toString() === '1'
        }
        return false
      },
      availableAdvStatusList () {
        return this.advStatusList
      },
      columnsShow () {
        const columns = {
          program_name: { label: 'Programme', mobile: true },
          signature_date: { label: 'Réservation', mobile: true }
        }
        if (this.isAdmin || this.isSectorManager) {
          columns.company_name = { label: 'Société', mobile: false }
        }
        if ((this.isAdmin || this.isSectorManager) && this.isDistributeurMode) {
          columns.promoteur_name = { label: 'Promoteur', mobile: false }
        }
        if (this.isAdmin || this.isManager || this.isSectorManager) {
          columns.seller_name = { label: 'Vendeur', mobile: true }
        }
        columns.buyer_name = { label: 'Acquéreur', mobile: true }
        columns.sale_date = { label: 'Acte', mobile: true }
        columns.destination = { label: 'Destination', mobile: false }
        columns.mandat_de_gestion = { label: 'Mandat de gestion', mobile: false }
        columns.reservation_date = { label: 'Enregistrement', mobile: false }
        columns.updated_on = { label: 'Modification', mobile: false }
        columns.contrat_de_reservation_is_valid = { label: 'Contrat de réservation', mobile: false }
        return columns
      },
      gedExportEnabled () {
        return JSON.parse(this.$configs.GED_ENABLED)
      }
    },
    watch: {
      'filters.destination' (v) {
        if (!v || !v.length || !v.includes('invest')) {
          this.filters.mandat_de_gestion = null
        }
      }
    },
    methods: {
      beforeResetFilters () {
        this.signatureDate = null
        this.saleDate = null
        this.reservationDate = null
      },
      goToAdvView (advPk) {
        this.$router.push({ name: 'AdvInfos', params: { id: advPk }, query: { returnId: advPk } })
        // if (this.isAdmin) {
        // } else {
        //   this.$router.push({name: 'AdvRecap', params: {id: advPk}})
        // }
      },
      beforeGet () {
        if (this.query.program && isPlainObject(this.query.program)) {
          this.query.program = this.query.program.pk
        }
        if (isPlainObject(this.query.lot)) {
          this.query.lot = this.query.lot.pk
        }
        if (isPlainObject(this.query.buyer)) {
          this.query.buyer = this.query.buyer.pk
        }
        if (isPlainObject(this.query.seller)) {
          this.query.seller = this.query.seller.pk
        }
        if (isPlainObject(this.query.company)) {
          this.query.company = this.query.company.pk
        }
        if (isPlainObject(this.query.promoteur)) {
          this.query.promoteur = this.query.promoteur.pk
        }
        if (isPlainObject(this.query.pole)) {
          this.query.pole = [this.query.pole.pk]
        }
        if (Array.isArray(this.query.pole)) {
          this.query.pole = uniq(this.query.pole.map(x => x.pk || x))
        }
      },
      updateProgramFilter (e) {
        this.$set(this.filters, 'program', e ? e.pk : null)
        this.$nextTick(() => {
          this.changeFilters()
        })
        this.getLots()
      },
      updateSaleDateFilter (e) {
        this.updateDateFilter(e, 'sale_date')
      },
      updateReservationDateFilter (e) {
        this.updateDateFilter(e, 'reservation_date')
      },
      updateSignatureDateFilter (e) {
        this.updateDateFilter(e, 'signature_date')
      },
      updateDateFilter: debounce(function (e, val) {
        if (e.length === 2 && (e[0] !== this.filters[`${val}__gte`] || e[1] !== this.filters[`${val}__lte`])) {
          this.$set(this.filters, `${val}__gte`, moment(e[0]).format('DD/MM/YYYY'))
          this.$set(this.filters, `${val}__lte`, moment(e[1]).format('DD/MM/YYYY'))
          this.$nextTick(() => {
            this.changeFilters()
          })
        } else if (e.length === 0) {
          this.$set(this.filters, `${val}__gte`, undefined)
          this.$set(this.filters, `${val}__lte`, undefined)
          this.$nextTick(() => {
            this.changeFilters()
          })
        }
      }, 500),
      getPrograms (query) {
        this.$api.programService.get({ name: query }).then(r => {
          this.programs = r.data.items
        })
      },
      getCountAdvs () {
        this.service.get({ status: ['reserved'], per_page: 1 }).then(r => {
          this.reservedAdvs = r.data.total
        })
      },
      updateLotFilter (e) {
        this.$set(this.filters, 'lot', e ? e.pk : null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateMandatFilter (e) {
        console.log(e)
        this.$set(this.filters, 'mandat_de_gestion', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateDestinationFilter (e) {
        this.$set(this.filters, 'destination', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      deleteDestinationFilter (i) {
        this.filters.destination.splice(i, 1)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      tagColors (v) {
        const COLORS = {
          reserved: 'is-reserve',
          sold: 'is-acte',
          canceled_by_admin: 'is-draft'
        }
        return COLORS[v]
      },
      getLots (query = null) {
        let params = {}
        if (query) {
          params.name = query
        }
        if ('program' in this.filters && isNil(this.filters.program) === false) {
          params.program = this.filters.program.pk || this.filters.program
        }
        this.$api.lotService.get(params).then(r => {
          this.lots = r.data.items
        })
      },
      updateSellerFilter (e) {
        this.$set(this.filters, 'seller', e ? e.pk : null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getSellers (query) {
        this.$api.userService.get({ last_name: query, sort: 'last_name:asc' }).then(r => {
          this.sellers = r.data.items
        })
      },
      updateBuyerFilter (e) {
        this.$set(this.filters, 'buyer', e ? e.pk : null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getBuyers (query) {
        this.$api.contactService.get({ last_name: query, sort: 'last_name:asc' }).then(r => {
          this.buyers = r.data.items
        })
      },
      updateCompanyFilter (e) {
        this.$set(this.filters, 'company', e ? e.pk : null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getCompanies (query) {
        this.$api.companyService.get({ name: query }).then(r => {
          this.companies = r.data.items
        })
      },
      updatePromoteurFilter (e) {
        this.$set(this.filters, 'promoteur', e ? e.pk : null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getPromoteurs (query) {
        this.$api.promoteurService.get({ name: query }).then(r => {
          this.promoteurs = r.data.items
        })
      },
      updatePoleFilter () {
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getPoles (query) {
        this.$api.poleService.get({ name: query, sort: 'name:asc' }).then(r => {
          this.poles = r.data.items
        })
      },
      deletePoleFilter (i) {
        this.filters.pole.splice(i, 1)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      personName (value) {
        if (value && value.last_name && value.first_name) {
          return `${value.last_name} ${value.first_name}`
        }
      },
      expordGed () {
        const apiUrl = this.$configs.APIROOT
        const exportURl = `${apiUrl}/export/ged2`
        let filename = moment().format('YYYY[_]MM[_]DD[-]HH[_]mm[_]ss')
        filename = `export-ged-${filename}.xlsx`
        downloadURI(exportURl, filename)
      },
      exportMultiselect () {
        const apiUrl = this.$configs.APIROOT
        const exportURl = `${apiUrl}/export/adv?pk[]=${this.selectedItems.join('&pk[]=')}`
        downloadURI(exportURl, 'ADV-export-GED.xlsx')
      },
      exportMultiselectLite () {
        const apiUrl = this.$configs.APIURL
        const exportURl = `${apiUrl}/advs-export-lite?pk[]=${this.selectedItems.join('&pk[]=')}`
        downloadURI(exportURl, 'ADV-export.xlsx')
      },
      openGedModal () {
        console.log('openGedModal...')
        this.gedExportModal = true
      }
    },
    created () {
      if (this.$route.query) {
        Object.assign(this.filters, this.$route.query)
        if (this.$route.query.signature_date__gte && this.$route.query.signature_date__lte) {
          this.signatureDate = this.$route.query.signature_date__gte + ' au ' + this.$route.query.signature_date__lte
        }
        if (this.$route.query.sale_date__gte && this.$route.query.sale_date__lte) {
          this.saleDate = this.$route.query.sale_date__gte + ' au ' + this.$route.query.sale_date__lte
        }
      }
      if (this.$route.query.status) {
        this.filters.status = Array.isArray(this.$route.query.status) ? this.$route.query.status : [this.$route.query.status]
      }
      if (this.$route.query.destination) {
        this.filters.destination = Array.isArray(this.$route.query.destination) ? this.$route.query.destination : [this.$route.query.destination]
      }
      this.sort('reservation_date', {
        order: 'desc',
        sort: true
      })
      this.getPrograms()
      this.getBuyers()
      this.getSellers()
      this.companies = this.companiesList.slice()
      this.getCountAdvs()
      this.poles = this.polesList.slice()
      if (this.isDistributeurMode) {
        this.promoteurs = this.promoteursList.slice()
      }
    }
  }
</script>

<style>
  is-annonce {
    background-color: #f87051
  }
</style>



// WEBPACK FOOTER //
// src/components/adv/AdvList.vue